import React from 'react'
import Chip from '@mui/material/Chip'
import SafetyCheckIcon from '@mui/icons-material/SafetyCheck'
import NoEncryptionGmailerrorredIcon from '@mui/icons-material/NoEncryptionGmailerrorred'
import { Tooltip, Zoom } from '@mui/material'

interface ComponentProps {
  twoFactorStatus: boolean
}

export const TwoFactorStatusChip: React.FC<ComponentProps> = ({ twoFactorStatus }: ComponentProps): JSX.Element => {
  let variant: 'outlined' | undefined
  let twoFactorLabel: string
  let color: 'primary' | 'warning' | 'error' | 'secondary' | 'success' | undefined

  if (twoFactorStatus) {
    color = 'primary'
    variant = 'outlined'
    twoFactorLabel = 'ENABLED'
  } else {
    variant = 'outlined'
    twoFactorLabel = 'Disabled'
  }

  const statusIcon = (status: boolean): JSX.Element => {
    if (status) {
      return <SafetyCheckIcon />
    } else {
      return <NoEncryptionGmailerrorredIcon />
    }
  }

  return (
    <Tooltip title={twoFactorLabel} TransitionComponent={Zoom} arrow placement='bottom'>
      {variant === undefined || variant === null
        ? (
          <Chip icon={statusIcon(twoFactorStatus)} label={twoFactorLabel} color={color}></Chip>
          )
        : (
          <Chip icon={statusIcon(twoFactorStatus)} label={twoFactorLabel} variant={variant} color={color} />
          )
      }
    </Tooltip>
  )
}
